import React, {FC, useState} from "react";
import {
  PaymentType,
  Role,
  Transaction as TransactionModel,
  TransactionStatus,
  TransactionType
} from "../../../../api-client";
import {cn, resultIf, RouteDictionary} from "../../../../utils";
import {GridRowHeader} from "../../../layout/grid";
import {Button, CustomLink, Money, PrimaryButton} from "../../../common";
import {useErrorCallback, useProfileData, useToggle} from "../../../../hooks";
import './Transaction.scoped.scss';
import {formatDate} from "../../../../formatters";
import {useTransactionsTranslation} from "../../../../hooks/useTransactionsTranslation";
import {MoneyMode} from "../../../common/utils/Money/Money";
import {PrimaryButtonColor} from "../../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {createInvestmentManager} from "../../../../di";
import moment from "moment";

interface Props {
    transaction: TransactionModel
}

const Transaction: FC<Props> = ({transaction}) => {
  const [active, toggle] = useToggle();
  const [loading, setLoading] = useState(false);
  const {role} = useProfileData();
  const handleError = useErrorCallback();
  const translateTransaction = useTransactionsTranslation();
  const isIncome = () => {
    return transaction.paymentType != PaymentType.DEBIT;
  };
  const cancelTransaction = async () => {
    const userConfirmed = window.confirm("Вы действительно хотите отменить инвестицию?");
    if (!userConfirmed) return;

    setLoading(true);
    try {
      if (transaction.objectUuid) {
        const manager = await createInvestmentManager();
        await manager.canselInvestment(transaction.objectUuid);
        alert("Инвестиция успешно отменена");
        window.location.reload();
      }
    } catch (err: any) {
      await handleError(err);
      alert("Ошибка при отмене транзакции");
    } finally {
      setLoading(false);
    }
  };

  const isCancel = transaction.status === TransactionStatus.PENDING &&
      transaction.transactionType === TransactionType.INVESTMENT && moment(transaction.date).add(5, 'd').isAfter(moment());
  const isReserve = transaction.status !== TransactionStatus.COMPLETED && transaction.transactionType === TransactionType.INVESTMENT;
  const isDeposit = transaction.transactionType === TransactionType.DEPOSIT;

  const renderTransactionTranslation = () => {
    if (isReserve) return 'Бронирование';
    if (isDeposit && role === Role.BORROWER) return 'Пополнение учетного счета';
    if (isDeposit && role === Role.LENDER) return 'Пополнение счета';
    else return translateTransaction(transaction.transactionType).text;
  };

  return (
    <li
      className={cn(
        "transaction",
        resultIf(active, "active")
      )}
      key={transaction.uuid}
    >
      <CustomLink to={RouteDictionary.DETAILED_PROJECT}
        params={{uuid: transaction.projectUuid}}
        key={transaction.uuid}
        className="transaction__column transaction__debt transactions__link" onClick={toggle}>
        <div className="transaction__text transaction__project">
          {transaction.projectName === undefined ? "Проект не указан" : transaction.projectName[0].text}
        </div>
      </CustomLink>
      <div className="transaction__column transaction__investment" onClick={toggle}>
        <GridRowHeader className="transaction__header">
          ID инвестиции
        </GridRowHeader>
        <div className="transaction__text">
          {transaction.objectCode}
        </div>
      </div>
      <div className="transaction__column transaction__date" onClick={toggle}>
        <GridRowHeader className="transaction__header">
          Дата транзакции
        </GridRowHeader>
        <div className="transaction__text">
          {formatDate(transaction.date)}
        </div>
      </div>
      <div className="transaction__column transaction__extra" onClick={toggle}>
        <div className="transaction__text">
          {transaction.taxPayment && (
            <>удержан НДФЛ: <Money money={transaction.taxPayment} /></>
          )}
        </div>
      </div>
      <div className="transaction__column transaction__type" onClick={toggle}>
        <div className="transaction__text">
          {renderTransactionTranslation()}
        </div>
      </div>
      <div className="transaction__column transaction__money" onClick={toggle}>
        <div className={resultIf(isIncome(), 'transaction--incoming')}>
          <span>
            {isIncome() ? "+" : "-"}
          </span>
          <Money money={transaction.money} mode={resultIf(isIncome(), MoneyMode.WRITE_OFF)}/>
        </div>
      </div>
      {/*<div className="transaction__column transaction__description">*/}
      {/*  <div>*/}
      {/*    <div className="transaction__text">*/}
      {/*      {translateTransaction(transaction.transactionType).description}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="transaction__description-close" onClick={() => setActive(false)}>*/}
      {/*    <Image src={descriptionClose} alt="Close description on mobile"/>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {isCancel && <div className="transaction__column transaction__cancel" onClick={cancelTransaction}>
        <PrimaryButton className={'transaction__cancel_button'} color={PrimaryButtonColor.GRAY} disabled={loading}>
          <Button>отменить инвестицию</Button>
        </PrimaryButton>
      </div>}
    </li>
  );
};

export default Transaction;